import { ComplementGroup } from '@app/types';

export function getComplementsGroupsSelected(groups: ComplementGroup[]) {
  const groupsSelected: ComplementGroup[] = [];
  for (const group of groups ?? []) {
    for (const complement of group.complementos ?? []) {
      if ((complement?.amount ?? 0) > 0) {
        groupsSelected.push(group);
        break;
      }
    }
  }
  return groupsSelected;
}
